<template>
    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <div class="md-vdatepicker">
                    <datetime v-model="demand.date" type="datetime" :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }">
                        <label slot="before">Date et heure *</label>
                    </datetime>
                    <validation-error :errors="apiValidationErrors.date" />
                </div>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-75">
                <div class="md-multiselect">
                    <label>Client</label>
                    <multiselect v-model="demand.client"
                                 :options="clients"
                                 :show-labels="false"
                                 @input="getLinkedDemands"
                                 placeholder="Client"
                                 label="name"
                                 track-by="name"
                                 open-direction="bottom">
                        <template slot="option" slot-scope="props">
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.name }}</span>
                            </div>
                        </template>
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                    <validation-error :errors="apiValidationErrors.client_id" />
                </div>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-75">
                <div class="md-multiselect">
                    <label>Site du client</label>
                    <multiselect v-model="demand.site"
                                 :disabled="!demand.client && !demand.site"
                                 :options="sites"
                                 :show-labels="false"
                                 @input="getLinkedDemands"
                                 placeholder="Site"
                                 label="name"
                                 track-by="name"
                                 open-direction="bottom">
                        <template slot="option" slot-scope="props">
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.name }}</span>
                            </div>
                        </template>
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                    <validation-error :errors="apiValidationErrors.site_id" />
                </div>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <md-field class="md-invalid">
                    <label>Prospect</label>
                    <md-input v-model="demand.prospect" type="text" name="prospect" :disabled="!!demand.client"></md-input>
                    <validation-error :errors="apiValidationErrors.prospect" />
                </md-field>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <label class="font-medium">Type de demande</label>
                <div class="flex items-center">
                    <div class="mr-2" v-for="demandType in demandTypes" :key="demandType.id">
                        <md-checkbox v-model="demand.demand_types" :value="demandType.id" class="mt-2">{{ demandType.name }}</md-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <md-field class="md-invalid">
                    <label>Sujet</label>
                    <md-input v-model="demand.subject" type="text" name="subject" required></md-input>
                    <validation-error :errors="apiValidationErrors.subject" />
                </md-field>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-100">
                <md-field class="md-invalid">
                    <label>Message</label>
                    <md-textarea v-model="demand.message" md-autogrow name="message" required></md-textarea>
                    <validation-error :errors="apiValidationErrors.message" />
                </md-field>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "DemandForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        demand: Object,
        errors: Array
    },
    data() {
        return {
            clients: [],
            sites: [],
            demandTypes: [],
            linkedDemands: [],
            modelDemandTypes: [],
        }
    },
    methods: {
        async getClients() {
            const { data } = await this.$store.dispatch('clients/fetchAllClientsWithSites')
            this.clients = data
            this.checkRouteQuery()
        },
        async getDemandsByProspect() {
            const { data } = await this.$store.dispatch('demands/fetchByProspect', {
                prospect: this.demand.prospect
            })
            this.linkedDemands = data
        },
        async getDemandTypes() {
            const { data } = await this.$store.dispatch('demandTypes/getDemandTypes')
            this.demandTypes = data
        },
	    async getLinkedDemands(event) {
			if(event) {
				const payload = { client_id: event.client_id ? event.client_id : event.id }
				if(event.client_id) {
					payload.site_id = event.id
				}
				const { data } = await this.$store.dispatch('demands/fetchLinkedDemands', payload)

				if(!event.client_id && event.id) {
					this.sites = event.sites
					this.demand.site = null
					this.$emit('selected', data)
				} else if(event.client_id) {
					this.$emit('selected', data)
				} else if(!event.client_id && !event.id) {
					this.sites = []
					this.demand.client = null
					this.demand.site = null
					this.$emit('selected', [])
				}
			} else {
				if(!this.demand.client) {
					this.sites = []
					this.demand.client = null
					this.demand.site = null
					this.$emit('selected', [])
				} else if(!this.demand.site) {
					const { data } = await this.$store.dispatch('demands/fetchLinkedDemands', {
						client_id: this.demand.client.id
					})
					this.$emit('selected', data)
				}
			}
	    },
        checkRouteQuery() {
            const { clientId, siteId } = this.$route.query
            if(clientId) {
                let client = this.clients.find(client => client.id === parseInt(clientId))
                this.demand.client = client
	            this.sites = client.sites
                if(siteId) {
					const site = client.sites.find(site => site.id === parseInt(siteId))
                    this.demand.site = site
	                this.getLinkedDemands(site)
                } else {
	                this.getLinkedDemands(client)
                }
            }
	        this.$emit('loaded')
        },
    },
    mounted() {
        this.getClients()
        this.getDemandTypes()
    },
    watch: {
        'demand.prospect'(newVal) {
            if(newVal) {
                this.getDemandsByProspect()
            }
        },
        errors(newVal) {
            this.resetApiValidation()
            if(newVal) {
                this.setApiValidation(newVal)
            }
        },
    }
}
</script>

<style scoped>

</style>
